'use strict';

/**
 * BD.FullCollection: Populates a container with all elements of a collection, sorted by date.
 */
var BD = window.BD = window.BD || {};
BD.FullCollection = (function($) {
  var $collectionContainer;
  
  function init(containerId, collectionHandle) {
    $collectionContainer = $('#' + containerId);
    BD.CollectionLoader.load(collectionHandle, collectionLoadedHandler);
  }
  
  function collectionLoadedHandler(collection) {
    var $products = collection.$allProducts.clone().children();

    $products.sort((a, b) => {
      var aYmd = a.querySelector('.tourbox').dataset.tourYmd || '';
      var bYmd = b.querySelector('.tourbox').dataset.tourYmd || '';
      return aYmd.localeCompare(bYmd);
    });
    
    $collectionContainer.empty().append($products);
  }
  
  return {
    init: init
  }
})(jQuery);